import React,{useEffect} from 'react';
import parologo from '../Assets/Images/plogo.png';
import{Link} from 'react-router-dom';
import { useLocation } from "react-router-dom";



function Parosidebar({sidebar,openLogForm}) {

      
    let role;
    useEffect(()=>{

     role=localStorage.getItem('RoleId')
     if(role==='02'){
        document.getElementById("Paro-Adduser").style.display="none"

            document.getElementById("Paro-Assign").style.display="none"
     }

     });

    const location = useLocation();
    const { pathname } = location;
     const splitLocation = pathname.split("/");


    
    return (
        <div className ={sidebar ? " parop-sidebar parop-sidebar--open" : "parop-sidebar"}  id="parop-sidebar">
    <div className='parop-sidebar-title'>
        <div className='parop-sidebar-img'>
            <img src={parologo} alt="logo"/>&nbsp;&nbsp;
            <span> Paropakari</span> 
        </div>
      
    </div>

   <div className='parop-sidebar-menu'>
    
    
    <div className= {splitLocation[1] === "ParoAdduser" ? "active-Paro" :
  splitLocation[1] === "ParoAddRole" ? "active-Paro" :'parop-sidebar-link'}id="Paro-Adduser">
    <i class="fa-solid fa-user-plus"></i>&nbsp; &nbsp;
        <Link to ="/ParoAdduser">Users</Link>
    </div>
  
    <div className= {splitLocation[1]=== "Paroprofile" ?  "active-Paro" :'parop-sidebar-link'}>
    <i class="fa-solid fa-user"></i>&nbsp; &nbsp;&nbsp;
        <Link to ="/Paroprofile">Profile</Link>
    </div>
   
    <div className= {splitLocation[1]=== "ParoSection" ?  "active-Paro" :
    splitLocation[1]=== "ParoCauses" ?  "active-Paro" :
    splitLocation[1]=== "ParoIndex" ?  "active-Paro" :
    splitLocation[1]=== "ParoPayment" ?  "active-Paro" :
    splitLocation[1]=== "ParoIndexbottom" ?  "active-Paro" :
    splitLocation[1]=== "ParoIndexSlider" ?  "active-Paro" :
    splitLocation[1]=== "ParoSectionIndexTop" ?  "active-Paro" : 'parop-sidebar-link'}>

    <i class="fa-solid fa-section"></i>&nbsp; &nbsp;&nbsp;&nbsp;
        <Link to ="/ParoSection">Section</Link>
    </div>
 

    

    <div className= { splitLocation[1]==="ParoAssign" ? "active-Paro" :'parop-sidebar-link'}id="Paro-Assign">
    <i class="fas fa-tasks"></i>&nbsp; &nbsp;&nbsp;
        < Link to ="/ParoAssign">Assign</Link>
    </div>


    <div className='parop-sidebar-link'>
    <i class="fa-solid fa-right-from-bracket"></i>&nbsp; &nbsp;&nbsp;
        <Link to =" " onClick={openLogForm}>Logout</Link>
    </div>
   
    
   </div>

  

{/* <div className="Paropop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="Paro-adduser-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="Paro-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div> */}

    </div>
    );
}

export default Parosidebar;